<script setup>
import ButtonSNS from '@/Shared/Buttons/ButtonSNS'
const snsInfo = [
  { name: 'line', url: 'https://line.me/R/ti/p/%40hqn6779h' },
  { name: 'instagram', url: 'https://instagram.com/aandfcorp' },
  { name: 'facebook', url: 'https://www.facebook.com/aandf.co.jp' },
  { name: 'twitter', url: 'https://twitter.com/aandf_corp' },
  { name: 'youtube', url: 'https://www.youtube.com/user/aandfinfo' },
  { name: 'flickr', url: 'https://www.flickr.com/photos/143597692@N05/' },
  { name: 'feedly', url: 'https://feedly.com/i/welcome/feed/https://blog.aandf.co.jp/blog/?feed=rss' },
]
</script>

<template>
  <ul class="flex flex-wrap justify-center content-center mx-[-10px]">
    <li v-for="item in snsInfo" :key="item['name']" class="p-[10px] first:pl-0 last:pr-0">
      <ButtonSNS :icon="item['name']" :url="item['url']" class="block h-auto w-[20px]" />
    </li>
  </ul>
</template>
